import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { RootState } from "../../redux/store";
import { fetchAlerts } from "../../services/apis";
import { setAlertsData, setAlertsCount } from "../../redux/Slice/Alerts/AlertsSlice";
import { useQuery } from "@tanstack/react-query";
import { getCurrentUser } from "aws-amplify/auth";
import { AlertBar } from "../../components";

// const IGNORED_PATHS = ["/upgrades", "/faq", "/contact-us", "/settings", "/terms", "/privacy"];
const url = process.env.REACT_APP_WSS_ENDPOINT || "";

// type AlertItem = {
//   alert_id: string;
//   timestamp: string;
//   site_name: string;
//   message: string;
//   alert_dismissed: string[];
// };

// type CommandAlertItem = {
//   toast_type: string;
//   pace_device_serial_number: string;
// };

const AlertSocket: React.FC = () => {
  // const location = useLocation();
  const dispatch = useDispatch();
  // const alerts = useSelector((state: RootState) => state.alerts.active_alerts);
  // const [messages, setMessages] = useState<AlertItem[]>(alerts);
  const [controlMsgs, setControlMsgs] = useState<any[]>([]);
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserId = async () => {
      const user = await getCurrentUser();
      setUserId(user.userId);
    };
    fetchUserId();
  }, []);

  const { data: alertsData, refetch } = useQuery({
    queryKey: ["alertsData"],
    queryFn: fetchAlerts,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    if (alertsData && userId) {
      dispatch(setAlertsData(alertsData.active_alerts));
      dispatch(setAlertsCount(alertsData?.active_count || 0));
      const filteredAlerts = alertsData.active_alerts.filter((alert) => !Array.isArray(alert.alert_dismissed) || !alert.alert_dismissed.includes(userId));
      // setMessages(filteredAlerts);
    }
  }, [alertsData, dispatch, userId]);

  // establish websocket connection
  useEffect(() => {
    const socket = new WebSocket(url);
    socket.onopen = () => console.log("WebSocket connected");

    socket.onmessage = (event) => {
      console.log("Received message:", event.data);
      try {
        const parsedData: { type: string; data: any } = JSON.parse(event.data);
        console.log("Parsed data:-------------------", parsedData);
        if (parsedData.type === "active_alerts") {
          // Refetch alertsData whenever a new WebSocket message of type "active_alerts" is received
          refetch();
        }
        if (parsedData.type === "command_control") {
          switch (parsedData.data.key) {
            case "bypass":
              if (parsedData.data.value) {
                return setControlMsgs((prevMsgs) => [...prevMsgs, `${parsedData.data.pace_device_serial_number} - Bypass completed.`]);
              } else {
                return setControlMsgs((prevMsgs) => [...prevMsgs, `${parsedData.data.pace_device_serial_number} - Take online completed.`]);
              }
            case "firmware":
              return setControlMsgs((prevMsgs) => [...prevMsgs, `${parsedData.data.pace_device_serial_number} - Firmware update completed.`]);
            case "reboot":
              return setControlMsgs((prevMsgs) => [...prevMsgs, `${parsedData.data.pace_device_serial_number} - Rebooting device.`]);
            default:
              return setControlMsgs((prevMsgs) => [...prevMsgs, `${parsedData.data.pace_device_serial_number} - ${parsedData.data.key} completed.`]);
          }
        }
      } catch (error) {
        console.error("Error parsing message:", error);
      }
    };

    socket.onclose = () => console.log("WebSocket disconnected");

    socket.onerror = (error) => console.error("WebSocket error:", error);

    return () => {
      // clearInterval(messageInterval);
      socket.close();
    };
  }, []);

  // const handleCloseAlert = (alertId: string) => {
  //   if (!userId) return;
  //   try {
  //     dismissAlert(alertId, userId);
  //     // setMessages((prevMessages) => prevMessages.filter((alert) => alert.alert_id !== alertId));
  //     refetch();
  //   } catch (error) {
  //     console.error("Error dismissing alert:", error);
  //   }
  // };

  const handleCloseControlMsg = (index: number) => {
    setControlMsgs((prevMsgs) => prevMsgs.filter((_, i) => i !== index));
  };

  // if (IGNORED_PATHS.includes(location.pathname)) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 10,
        bottom: 10,
        right: 10,
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        maxWidth: "350px",
        pointerEvents: "none",
      }}
    >
      {/* Render standard alerts */}
      {/* {messages.map((alert) => (
        <AlertBar key={alert.alert_id} severity="error" title={alert.timestamp} description={alert.message} isClose show setShow={() => handleCloseAlert(alert.alert_id)} isFixed={true} />
      ))} */}

      {/* Render control messages */}
      {controlMsgs.map((commandMsg, index) => (
        <AlertBar key={index} severity={"success"} title={""} description={commandMsg} isClose show setShow={() => handleCloseControlMsg(index)} isFixed={true} />
      ))}
    </div>
  );
};

export default AlertSocket;
